let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledBlurredContainer = styledWithTheme.div(_t || (_t = _`
  filter: ${0};
  pointer-events: ${0};
  user-select: ${0};
`), ({
  isBlurred
}) => isBlurred ? 'blur(3.25px)' : 'none', ({
  isBlurred
}) => isBlurred ? 'none' : 'auto', ({
  isBlurred
}) => isBlurred ? 'none' : 'auto');
export const Blurrable = props => {
  const {
    children,
    isBlurred
  } = props;
  return /*#__PURE__*/_jsx(StyledBlurredContainer, {
    isBlurred: isBlurred,
    "data-test-id": "blurredOverlay",
    children: children
  });
};